<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor">
    <path :d="path"/>
  </svg>
</template>

<script>
  export default {
    name: "EmptySvg",
    props:{
      path: {
        type: String,
      }
    }
  }
</script>

<style scoped>

</style>